<template>
<v-textarea
    :label=label
    :value="value"
    disabled
    :rows="1"
    auto-grow
>

    <span
        slot="append-outer"
    >
         <m-edit-menu
            v-if="!read_only"
            :menu_items="menu_items"
            v-on:menu-action="onMenuAction($event)"
         />

        <m-edit-textarea-dialog
            ref="edit-dialog"
            v-if="!read_only && !use_compose_message"
            :rules="validationRules()"
            v-on:ok="setValue($event)"
            :show_message_type="show_message_type"
            :force_mms="force_mms"
        />

         <m-compose-message-dialog
             ref="edit-dialog"
             v-if="!read_only && use_compose_message"
             v-on:ok="setValue($event)"
             :hint="hint"
             confirm_text="Save &amp; Close"
             :rules="validationRules()"
             :show_message_type="show_message_type"
            :force_mms="force_mms"
            :insert_chips="insert_chips"
         />

    </span>


</v-textarea>
</template>

<script>
const _ = require('lodash');

export default {
    props: {

        label: {
            type: String,
            default: function () { return ''; }
        },

        value: {
            type: [String, Number],
            default: function() { return ''; }
        },

        read_only: {
            type: Boolean,
            default: function() { return false; }
        },

        menu_items: {
            type: Array,
            default: function() { return []; }
        },

        optional: {
            type: Boolean,
            default: function() { return false; }
        },

        integer: {
            type: Boolean,
            default: function() { return false; }
        },

        integer_positive: {
            type: Boolean,
            default: function() { return false; }
        },

        integer_positive_non_zero: {
            type: Boolean,
            default: function() { return false; }
        },

        rules: {
            type: Array,
            default: function() { return []; }
        },

        hint : {
            type: String,
            default: function() { return null; }
        },

        use_compose_message: {
            type: Boolean,
            default: function () { return false; }
        },

        show_message_type: {
            type: Boolean,
            default: function () { return false; }
        },

        force_mms: {
            type: Boolean,
            default: function () { return false; }
        },

        insert_chips: {
            type: Array,
            default: function() { return []; }
        },
    },

    methods: 
    {
        onMenuAction(menu_item)
        {
            if ( menu_item.event == 'edit' )
            {
                this.onEdit();
                return;
            }

            this.$emit(menu_item.event, menu_item);
        },

        onEdit() 
        {
            if ( this.use_compose_message )
            {
                this.$refs['edit-dialog'].showDialog(this.value);
            }
            else
            {
                this.$refs['edit-dialog'].showDialog(this.label, this.value, this.hint);
            }
        },

        setValue(new_value)
        {
            this.$emit('input',new_value);
        },

        validationRules()
        {
            let required = value => {
                if ( value == null ) return 'Required.';
                if ( (''+value).trim().length == 0 ) return 'Required.';
                return true;
            };

            let integer = value => {
                if ( value == null ) return 'Must be an integer';
                if ( isNaN(Number(value)) || Number(value) != parseInt(value) ) return 'Must be an integer';
                return true;
            };

            let integer_positive = value => {
               let int_value = Number(value);
               if ( isNaN(int_value) || int_value < 0 || int_value != parseInt(value) ) return 'Must be a positive integer';
               return true;
            };

            let integer_positive_non_zero = value => {
               let int_value = Number(value);
               if ( isNaN(int_value) || int_value < 1 || int_value != parseInt(value) ) return 'Must be a non-zero positive integer';
               return true;
            };

            let ret = _.cloneDeep(this.rules);
            
            if ( !this.optional )
                ret.push(required);
            
            if ( this.integer )
                ret.push(integer);

            if ( this.integer_positive )
                ret.push(integer_positive);

            if ( this.integer_positive_non_zero )
                ret.push(integer_positive_non_zero);

            return ret;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>